import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import { LoaderType } from 'src/app/common/models/enums/common.enum';

@Injectable({
  providedIn: 'root'
})
export class ReportPopulationService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  getPopulationTotalReport(year = null){
    
    let url: string = `${environment.miUrl}${apiEndPoints.populationTotalReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getPopulationYearWiseReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.populationYearWiseReport}${changeParams}`;
    return this.apiServive.get(url);
  }

  getPopulationTrendlineReport(){
    let url: string = `${environment.miUrl}${apiEndPoints.populationTrendlineReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getPopulationAgeWiseReport(){
    let url: string = `${environment.miUrl}${apiEndPoints.populationAgeWiseReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

}
